function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMovie = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9 18a9 9 0 1 1 9-9 9.01 9.01 0 0 1-9 9M7.665 5.064a.92.92 0 0 0-.916.917v6.042a.92.92 0 0 0 .917.916.9.9 0 0 0 .443-.116L12.631 9.8a.915.915 0 0 0 0-1.6L8.109 5.18a.9.9 0 0 0-.444-.116",
  "data-name": "\\uC81C\\uC678 1",
  style: {
    fill: "#fff"
  },
  transform: "translate(.001)"
}));
export default SvgIconMovie;